import { createFileRoute, redirect } from "@tanstack/react-router";

// Preserve indexed URLs and existing bookmarks.
export const Route = createFileRoute("/nica-hoy")({
  beforeLoad: () => {
    throw redirect({ to: "/tiempos-nica-hoy", statusCode: 301 });
  },
});
